import { Component, Input, Inject, OnInit } from '@angular/core';
import { ConceptFamilyModel } from './conceptfamily.model';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ConceptFamilyListComponent } from './conceptfamily-list.component';
import { DummyComponent } from '../../../shared/dummy.component';
import { ConceptFamilyService } from './conceptfamily.service';
import { Router } from '@angular/router';
import { FilesService } from '../../file/files.service';

@Component({
    selector: 'convfact-conceptfamily-form',
    templateUrl: './conceptfamily-form.component.html',
    styleUrls: ['./conceptfamily.component.css'],
    standalone: false
})

export class ConceptFamilyFormComponent implements OnInit {
  @Input() conceptfamily: ConceptFamilyModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;

  uid: string = this.data.uid;
  ready = false;

  imageUpload = false;
  image: any;
  path: string;
  urlImage: any;
  imageReady = false;
  IsDirectPosAccessTpv= false;

  constructor(
    public dialogRef: MatDialogRef<ConceptFamilyListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dummy: DummyComponent,
    private conceptFamilyService: ConceptFamilyService,
    private fileService: FilesService,
    public snackBar: MatSnackBar,
    private router: Router
  ) { }

 ngOnInit() {
  if (this.uid !== null) {
    this.conceptFamilyService.loadData(this.uid).then(response => {
      this.conceptfamily = response;


      this.conceptfamily.isDirectPosAccessTpv = !!response.isDirectPosAccessTpv;

      if (this.conceptfamily.imageId != 0) {
        this.fileService.returnFileTPV(this.conceptfamily.imageId).then(imgResponse => {
          this.urlImage = imgResponse;
          this.imageReady = true;
        });
      } else {
        this.imageReady = false;
      }

      this.ready = true;
    });
  } else {
    this.ready = true;
  }
}



  deleteImage() {
    const fileId = this.conceptfamily.imageId;
    this.conceptfamily.imageId = 0;
    this.conceptFamilyService.editData(this.conceptfamily.uid, this.conceptfamily);
    this.fileService.deleteFileTPV(fileId);
    this.dummy.redirectTo(this.router.url);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  uploadImage(event) {
    this.image = event;
    this.imageUpload = true;
    this.path = "files/Imagenes/Familia Conceptos";
  }

  save(conceptfamily: ConceptFamilyModel) {
    this.dialogRef.close();
    if (this.imageUpload) {
      this.conceptFamilyService.addData(conceptfamily)

      const fileList: FileList = this.image.target.files;
      const type = "Image";
      if (fileList.length > 0 && fileList.length <= 10) {
        const file: File = fileList[0];
        const self = this;
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = function () {
          window.URL.revokeObjectURL(img.src);
          if (img.naturalWidth > 200 && img.naturalHeight > 200) {
            self.fileService.createFile(file, type, conceptfamily.name, self.path).then(response => {
              conceptfamily.imageId = response.id;
              self.saveData(conceptfamily);
            });
          } else {
            self.displayInfo("La imagen debe ser superior a 200px");
          }
        }
      }
    } else {
      this.saveData(conceptfamily);
    }
  }

  saveData(conceptfamily: ConceptFamilyModel) {
    if (conceptfamily.uid == null) {
      this.conceptFamilyService.addData(conceptfamily)
        .then(conceptfamily => {
          this.conceptFamilyService.editData(conceptfamily.uid, conceptfamily)

          this.conceptfamily = conceptfamily;
          this.dummy.redirectTo(this.router.url);
        })
        .catch(errors => this.errors = JSON.parse(errors['error'])['data']);
    } else {
      this.conceptFamilyService.editData(conceptfamily.uid, conceptfamily)
        .then(conceptfamily => {
          this.conceptfamily = conceptfamily;
          this.dummy.redirectTo(this.router.url);
        })
        .catch(errors => this.errors = JSON.parse(errors['error'])['data']);
    }
  }

  changeToggle(element, other) {
    this.conceptfamily[other] = (this.conceptfamily[element]);
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 4500;
    this.snackBar.open(message, '', options);
  }

}
